/* eslint-disable react/prop-types */
import { TextCell } from '../types'
import clsx from 'clsx'
import { Popover, PopoverContent, PopoverTrigger, Textarea } from '../../../shadcn'
import { createRenderer } from './renderer'
import { NOL } from './null'
import { BlockKeys, EditorFooter } from './utils'
import { useCallback, useEffect, useRef } from 'react'

export const Text = createRenderer<TextCell>({
  View: ({ className, cell }) => {
    return (
      <div className={clsx(className, 'truncate', { 'computed-cell': cell.computed })}>
        {cell.content ?? cell.value ?? <NOL />}
      </div>
    )
  },
  Editor: ({ className, cell, onRowChange, ...props }) => {
    const ref = useRef<HTMLTextAreaElement>(null)
    const handleKeyDown = useCallback((e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.stopImmediatePropagation()
        e.preventDefault()
      }
    }, [])
    useEffect(() => {
      if (ref.current) {
        ref.current.addEventListener('keydown', handleKeyDown)
      }
      return () => {
        if (ref.current) {
          ref.current.removeEventListener('keydown', handleKeyDown)
        }
      }
    }, [ref])

    const handleSave = useCallback(() => {
      props.onClose(true)
    }, [props.onClose])

    return (
      <div className={clsx(className, 'h-full', { 'computed-cell': cell.computed })}>
        <Popover open={true}>
          <PopoverTrigger className="text-left w-full h-full">
            <div className="pl-2 truncate">{cell.content ?? cell.value ?? <NOL />}</div>
          </PopoverTrigger>
          <PopoverContent className="p-0 border-none rounded-b-md overflow-hidden">
            <BlockKeys onEscape={() => props.onClose(true)} blockedKeys={['Enter']}>
              <Textarea
                ref={ref}
                value={cell.value ?? ''}
                rows={4}
                placeholder="Enter text..."
                // Set cursor to the end of the text
                onFocus={(e) => {
                  e.target.setSelectionRange(e.target.value.length, e.target.value.length)
                }}
                onChange={(e) =>
                  onRowChange({
                    ...props.row,
                    [props.column.key]: { type: 'string', value: e.target.value, computed: cell.computed },
                  })
                }
                className="w-full ps-1 outline-none focus-visible:ring-0 resize-none focus:outline-none rounded-b-none"
              />
            </BlockKeys>
            <EditorFooter handleSave={handleSave} />
          </PopoverContent>
        </Popover>
      </div>
    )
  },
})
